
import { css } from 'lit';
export default css`
/*
 * align-top prevents the whitespace "dangle" of inline blocks (which gives room
 * for the the dangly bits of letters like "g".
*/

:host {
  display: inline-block;
  width: 100%;
  fill: currentColor;
  vertical-align: top;
}

svg {
  vertical-align: top;
}

.icon {
  position: relative;
}

.icon--middle svg {
  vertical-align: middle;
}

.icon--location-filter-arrow svg {
  height: auto;
}

.icon--location-filter-arrow svg {
  width: 0.75rem;
}

.icon--location-filter-arrow svg {
  vertical-align: middle;
}

.icon--location-filter-arrow svg {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.icon--location-hero svg {
      height: 1.6875rem;
      margin-top: -.36rem;
    }

.icon--select-icon svg {
      width: 1.5rem;
      height: 1.5rem;
    }

.icon--card-icon svg {
  height: 3rem;
}
`;